module.exports = {
  smartFilters: [
    //Streams
    {
      type: "RECENTLY_VIEWED_STREAMS",
      name: "Recently Viewed Streams",
      contentType: "STREAM",
      description:
        "Streams that were recently viewed by the user so they can pick up from exactly where they dropped off.",
      icon: "/images/hub/smartFilters/continue_where_you_left.svg",
    },

    //Collections
    {
      type: "MY_COLLECTIONS",
      name: "My Collections",
      contentType: "COLLECTION",
      description:
        "Collections created by and collaborated with the user so they can find everything they need without leaving the Hub.",
      icon: "/images/hub/smartFilters/continue_where_you_left.svg",
    },

    //Assets
    {
      type: "MOST_VIEWED_ASSETS",
      name: "Popular with your teams",
      contentType: "ASSET",
      description:
        "This content slaps! Discover the assets that are more popular than casual Friday among your peers.",
      icon: "/images/hub/smartFilters/continue_where_you_left.svg",
    },
    {
      type: "RECENTLY_VIEWED_ASSETS",
      name: "Continue where you left",
      contentType: "ASSET",
      description: "Assets that were recently viewed by the user so they can pick up from exactly where they dropped off. ",
      icon: "/images/hub/smartFilters/frequently_shared_assets.svg",
    },
    {
      type: "RECENTLY_ADDED_ASSETS",
      name: "Recent additions to Hub",
      contentType: "ASSET",
      description:
        "Fresh content, served hot. Unlike that coffee you forgot about an hour ago.",
      icon: "/images/hub/smartFilters/recent_additions_to_hub.svg",
    },
    {
      type: "RECOMMENDED_ASSETS",
      name: "Recommended Assets",
      contentType: "ASSET",
      description:
        "Paperflite's AI recommends assets based on similar users' reading patterns. It’s like Tinder, but for your content.",
      icon: "/images/hub/smartFilters/frequently_shared_assets.svg",
    },
    {
      type: "RECENTLY_UPDATED_ASSETS",
      name: "Recently Updated Assets",
      contentType: "ASSET",
      description:
        "Check out which assets have been recently edited or changed by your team.",
      icon: "/images/hub/smartFilters/recently_updated_assets.svg",
    },
    {
      type: "FREQUENTLY_SHARED_ASSETS",
      name: "Frequently Shared Assets",
      contentType: "ASSET",
      description:
        "Your Champion Assets! These are the most shared by your team—let’s give them some love!",
      icon: "/images/hub/smartFilters/frequently_shared_assets.svg",
    },
  ],
};
